import { render, staticRenderFns } from "./TableStat.vue?vue&type=template&id=34b6fa3b&scoped=true&"
import script from "./TableStat.vue?vue&type=script&lang=js&"
export * from "./TableStat.vue?vue&type=script&lang=js&"
import style0 from "./TableStat.vue?vue&type=style&index=0&id=34b6fa3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b6fa3b",
  null
  
)

export default component.exports